import { useContext } from "react";
import "../Stylesheets/success.css"
import { ProductsContext } from "../contexts/ProductsContext";
import { createOrder } from "../Utils/NetworkApis";
export default function Success(){
   const { priceDetails } = useContext(ProductsContext)

    const makePayment = () =>{
       createOrder(priceDetails.price)
       const amount = priceDetails.price*100;
        var options = {
            "key": "rzp_test_IpvXn74a5utSvH", // Enter the Key ID generated from the Dashboard
            "amount": "amount", // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "BuyYourTime", //your business name
            "description": "Test Transaction",
            "image": "https://example.com/your_logo",
            "order_id": "order_MHbVVGLCHGEKl6", //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "handler": function (response){
                alert(response.razorpay_payment_id);
                alert(response.razorpay_order_id);
                alert(response.razorpay_signature)
            },
            "prefill": { //We recommend using the prefill parameter to auto-fill customer's contact information, especially their phone number
                "name": "Gaurav Kumar", //your customer's name
                "email": "gaurav.kumar@example.com", 
                "contact": "9000090000"  //Provide the customer's phone number for better conversion rates 
            },
            "notes": {
                "address": "Razorpay Corporate Office"
            },
            "theme": {
                "color": "#3399cc"
            }
        };
        var rzp1 = new Razorpay(options);
        rzp1.open()
        rzp1.on('payment.failed', function (response){
                alert(response.error.code);
                alert(response.error.description);
                alert(response.error.source);
                alert(response.error.step);
                alert(response.error.reason);
                alert(response.error.metadata.order_id);
                alert(response.error.metadata.payment_id);
        });
    }

    return(
        <div>
            {/* <h1>Your order has been placed successfully... It will be delivered soon!</h1> */}
            <button onClick={()=>{makePayment()}} >Pay Now</button>
        </div>
    )
}